import React from 'react';
import { Mail, Phone, MapPin, Youtube, Facebook, MessageCircle, ArrowUp } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import styles from './Footer.module.css';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.brandCol}>
            <div className={styles.logo}>
              <img src="/logo.png" alt="Ananta Anchor Logo" className={styles.logoImg} />
            </div>
            <p className={styles.description}>
              {t('footer_desc')}
            </p>
            <div className={styles.socials}>
              <a href="#" className={styles.socialIcon}><Youtube size={20} /></a>
              <a href="#" className={styles.socialIcon}><Facebook size={20} /></a>
              <a href="#" className={styles.socialIcon}><MessageCircle size={20} /></a>
            </div>
          </div>

          <div className={styles.linksCol}>
            <h4 className={styles.colTitle}>{t('footer_links')}</h4>
            <ul className={styles.list}>
              <li><a href="#about">{t('nav_tech')}</a></li>
              <li><a href="#samples">{t('nav_samples')}</a></li>
              <li><a href="#pricing">{t('nav_pricing')}</a></li>
              <li><a href="#services">{t('nav_services')}</a></li>
            </ul>
          </div>

          <div className={styles.contactCol}>
            <h4 className={styles.colTitle}>{t('footer_contact')}</h4>
            <ul className={styles.list}>
              <li><Phone size={18} color="#e87355" /> +91 7533928185</li>
              <li><Mail size={18} color="#e87355" /> info@anantainfotech.com</li>
              <li><MapPin size={18} color="#e87355" /> Dineshpur , Rudrapur , udham singh nagar , uttarakhand </li>
            </ul>
          </div>
        </div>

        <div className={styles.bottomBar}>
          <p>{t('footer_rights')}</p>
          <p1>Designed by Ananta Team</p1>
          <button className={styles.scrollTop} onClick={() => window.scrollTo({top:0, behavior:'smooth'})}>
            <ArrowUp size={20} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;